/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import MaterialSelect from '../utils/MaterialSelect';
import CurrencyFormat from '../utils/CurrencyFormat';
import useRentTimeData from '../../hooks/useRentTimeData';
import useTotalData from '../../hooks/useTotalData';

const ModelToCompare = (props) => {

    const { amount, getSelectedUnitLabel } = useRentTimeData();
    const { getCarTotal } = useTotalData();
    const [currentCar, setCurrentCar] = useState(props.selectedCar);

    const handleCarSelect = car => {
        setCurrentCar(car);
        if(props.onChangeCar){
            props.onChangeCar(car);
        }
    }

    const checkPrice = (price) => {
        if (price) {
            return (<CurrencyFormat value={price} />);
        }
        else {
            return (
                <>
                    <span>$ </span>
                    <span className="empty-price">---</span>
                </>
            );
        }
    }

    return (
        <div className={"model-to-compare " + (currentCar ? "" : "no-print empty")}>
            <div className="model-image">
            { currentCar ? <img src={currentCar.photo_1.url} alt={currentCar.name}></img> : null }
            </div>
            <MaterialSelect onCarSelect={handleCarSelect} selectedCar={currentCar} defaultText="Selecciona un Toyota" isModal={true}/>
            <div className="model-price-list">
                <ul>
                    <li>
                        <p>
                            Por hora
                        </p>
                        <strong>
                            {checkPrice(currentCar ? currentCar.hourly_rate : null)}
                        </strong>
                    </li>
                    <li>
                        <p>
                            Por día
                        </p>
                        <strong>
                            {checkPrice(currentCar ? currentCar.daily_rate : null)}
                        </strong>
                    </li>
                    <li>
                        <p>
                           {/*  Franquicia */}
                        </p>
                        <strong>
                            {checkPrice(currentCar ? currentCar.max_insurance_cost : null)}
                        </strong>
                    </li>
                </ul>
            </div>
        
            <div className="total-price-box">
                <p>Total {amount > 0 ?
                 <strong>por {amount} {getSelectedUnitLabel()}</strong>
                 : ""}</p>
                <p>
                    <span>
                        {checkPrice(currentCar ? getCarTotal(currentCar) : null)}
                    </span>
                </p>
            </div>
        
        </div>
    );

}
ModelToCompare.defaultProps = {
    selectedCar: null
};
export default ModelToCompare;